export const getCurrentView = state => state.ui.currentView;
export const getActiveTab = state => state.ui.activeTab;
export const getCurrentPortalElement = state => state.ui.currentPortalElement;